// extracted by mini-css-extract-plugin
export default {"PfsDueDates":"PFSDueDates_PfsDueDates__6wQPX","SubtitleText":"PFSDueDates_SubtitleText__rt+VN"};